import { getCarLots } from './getCarLots'
import { getAllUsersLeads } from './getAllUsersLeads'
// import { getDeletedLeadUsers } from './getDeletedLeadUsers'

export const Framework = {
  getCarLots,
  getAllUsersLeads,
  // ID-90076 se comenta método ya que la consulta que ejecuta es muy pesada,
  // se cambia por una más simple preguntando sólo por los usuarios que devuelve la consulta getAll,
  // ya que ya no se necesita saber todos los usuarios eliminados (se elimina bloque del frontend
  // getDeletedLeadUsers
}
